'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    border-radius: 50%;\n    background-color: ', ';\n    margin: auto;\n    width: 24px;\n    height: 24px;\n'], ['\n    border-radius: 50%;\n    background-color: ', ';\n    margin: auto;\n    width: 24px;\n    height: 24px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    margin: auto;\n    cursor: pointer;\n'], ['\n    margin: auto;\n    cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    ', '\n'], ['\n    position: relative;\n    ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    ', '\n    ', '\n'], ['\n    ', '\n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rcSlider = require('rc-slider');

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _alignments = require('../../constants/alignments');

var _sizes = require('../../constants/sizes');

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _colors = require('../../constants/colors');

var _clear = require('../../atoms/icons/clear');

var _clear2 = _interopRequireDefault(_clear);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _switch = require('../../atoms/switch');

var _switch2 = _interopRequireDefault(_switch);

var _link = require('../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _dropDown = require('../../molecules/lists/dropDown');

var _dropDown2 = _interopRequireDefault(_dropDown);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _style = require('./style');

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AvatarContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject, function (_ref) {
    var color = _ref.color;
    return color ? color : _colors.Colors.StrokeDark;
});

var DeleteDropDown = (0, _styledComponents2.default)(_container2.default)(_templateObject2);

var SliderColumn = (0, _styledComponents2.default)(_column2.default)(_templateObject3, function (_ref2) {
    var bottom = _ref2.bottom;
    return bottom && 'margin-bottom: ' + (0, _getSize2.default)(bottom) + 'px;';
});

var StyledSlider = (0, _styledComponents2.default)(_rcSlider2.default)(_templateObject4, { SliderStyles: _style.SliderStyles }, function (_ref3) {
    var disabled = _ref3.disabled;
    return disabled && '\n        .rc-slider-handle {\n            cursor: not-allowed;\n        }\n    ';
});

var Classification = function Classification(props) {
    var _useState = (0, _react.useState)([]),
        _useState2 = _slicedToArray(_useState, 2),
        selectedClassifications = _useState2[0],
        setSelectedClassifications = _useState2[1]; // Contains all selected classifications with id and percentage


    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        addClassifications = _useState4[0],
        setAddClassifications = _useState4[1]; // Switch for add more


    var _useState5 = (0, _react.useState)([].concat(_toConsumableArray(Array(1).keys()))),
        _useState6 = _slicedToArray(_useState5, 2),
        arrayID = _useState6[0],
        setArrayID = _useState6[1]; // Array of classification IDs (generated only in this component)


    var _useState7 = (0, _react.useState)([100]),
        _useState8 = _slicedToArray(_useState7, 2),
        sliderValue = _useState8[0],
        setSliderValue = _useState8[1]; // Percentage value (incremental e.g: [25, 50, 75, 100])


    var _useState9 = (0, _react.useState)({}),
        _useState10 = _slicedToArray(_useState9, 2),
        sliderMarks = _useState10[0],
        setSliderMarks = _useState10[1]; // Percentage value for display (actual value e.g. [25, 25, 25, 25])


    var _useState11 = (0, _react.useState)(false),
        _useState12 = _slicedToArray(_useState11, 2),
        error = _useState12[0],
        setError = _useState12[1];

    (0, _react.useEffect)(function () {

        if (!(0, _fastDeepEqual2.default)(props.selectedValues, selectedClassifications) && props.selectedValues) {
            var selectedValues = props.selectedValues.splice(0, 4);
            setSelectedClassifications(selectedValues);
            if (selectedValues.length > 1) {
                setAddClassifications(true);
                var ids = [],
                    arrPercentage = [];
                selectedValues.map(function (classification, idx) {
                    ids.push(idx);
                    arrPercentage.push(classification.percentage);
                });
                setArrayID(ids);
                var classificationDistribution = arrPercentage.map(function (elem, index) {
                    return arrPercentage.slice(0, index + 1).reduce(function (a, b) {
                        return a + b;
                    });
                });
                setSliderValue(classificationDistribution);
                updateMarks(classificationDistribution);
            } else {
                setAddClassifications(false);
                setArrayID([].concat(_toConsumableArray(Array(1).keys())));
                setSliderValue([100]);
                setSliderMarks({});
            }
        }
    }, [props.selectedValues]);

    // Props values
    var label = props.label;
    var placeholder = props.placeholder;
    var addClassificationHeader = props.addClassificationHeader;
    var percentageHeader = props.percentageHeader;
    var selectionColors = props.selectionColors || ['' + _colors.Colors.Primary, '' + _colors.Colors.Secondary, '' + _colors.Colors.Tertiary, '' + _colors.Colors.Success];
    var bottom = props.bottom;
    var top = props.top;
    var readOnly = false;
    if (props.editing === false) {
        readOnly = true;
    }

    // Update percentage of selected classifications
    var updateSelectionPercentage = function updateSelectionPercentage(arrSelection, arrVal, action) {
        if (action === 'remove') {
            arrSelection.map(function (x) {
                return props.changeEvent({ componentCode: 'Row' + x.id, value: x.value, code: x.code, percentage: x.percentage, action: "remove" });
            });
        } else {
            var selected = arrSelection.map(function (x, id) {
                return _extends({}, x, { "percentage": arrVal.map(function (elem, idx) {
                        return idx > 0 ? arrVal.slice(idx - 1, idx + 1).reduce(function (a, b) {
                            return b - a;
                        }) : elem;
                    })[id] });
            });
            setSelectedClassifications(selected);
            selected.map(function (x) {
                return props.changeEvent({ componentCode: 'Row' + x.id, value: x.value, code: x.code, percentage: x.percentage });
            });
        }
    };

    // Update display mark values
    var updateMarks = function updateMarks(values) {
        var marksObj = {};
        if (values[0]) {
            marksObj['' + values[0]] = _react2.default.createElement(_label2.default, { text: values[0] + '%', color: selectionColors[0], bold: true });
        };
        if (values[1]) {
            marksObj['' + values[1]] = _react2.default.createElement(_label2.default, { text: values[1] - values[0] + '%', color: selectionColors[1], bold: true });
        };
        if (values[2]) {
            marksObj['' + values[2]] = _react2.default.createElement(_label2.default, { text: values[2] - values[1] + '%', color: selectionColors[2], bold: true });
        };
        if (values[3]) {
            marksObj['' + values[3]] = _react2.default.createElement(_label2.default, { text: values[3] - values[2] + '%', color: selectionColors[3], bold: true });
        };
        setSliderMarks(_extends({}, marksObj));
    };

    // Update state on slider change
    var updateSliderValues = function updateSliderValues(arrSelection, numOfClassifications, action) {
        var arrPercentage = numOfClassifications === 3 ? [35, 35, 30] : Array(numOfClassifications).fill(100 / numOfClassifications);
        var classificationDistribution = arrPercentage.map(function (elem, index) {
            return arrPercentage.slice(0, index + 1).reduce(function (a, b) {
                return a + b;
            });
        });
        setSliderValue(classificationDistribution);
        updateMarks(classificationDistribution);
        arrSelection && updateSelectionPercentage(arrSelection, classificationDistribution, action);
    };

    // Remove classification
    var removeClassification = function removeClassification(id) {
        var newSelection = selectedClassifications.filter(function (x) {
            return x.id != id;
        });
        var removedSelection = selectedClassifications.filter(function (x) {
            return x.id === id;
        });

        var remainingID = arrayID.filter(function (x) {
            return x != id - 1;
        });
        setArrayID(remainingID);
        updateSliderValues(removedSelection, remainingID.length, "remove");
        updateSliderValues(newSelection, remainingID.length, "add");
        remainingID.length === 1 && setAddClassifications(false);
    };

    // Switch to add or remove all classifications
    var addMoreSwitch = function addMoreSwitch(value) {
        var totalPercentage = selectedClassifications.reduce(function (acc, selection) {
            return selection.percentage + acc;
        }, 0);
        if (selectedClassifications.length < arrayID.length || totalPercentage < 100) {
            setError(true);
        } else {
            setAddClassifications(!addClassifications);
            if (value) {
                var numOfClassifications = arrayID.length + 1;
                setArrayID([].concat(_toConsumableArray(Array(numOfClassifications).keys())));
                updateSliderValues(selectedClassifications, numOfClassifications, "add");
            } else {
                setArrayID([].concat(_toConsumableArray(Array(1).keys())));
                var resetSelection = selectedClassifications.filter(function (x) {
                    return x.id === 1;
                });
                var removedSelection = selectedClassifications.filter(function (x) {
                    return x.id != 1;
                });
                updateSliderValues(removedSelection, 1, "remove");
                updateSliderValues(resetSelection, 1, "add");
            }
        }
    };

    // Link to add more classifications 
    var addMore = function addMore() {
        var totalPercentage = selectedClassifications.reduce(function (acc, selection) {
            return selection.percentage + acc;
        }, 0);
        if (selectedClassifications.length < arrayID.length || totalPercentage < 100) {
            setError(true);
        } else {
            var remainingNo = [0, 1, 2, 3].filter(function (x) {
                return !arrayID.includes(x);
            });
            var nextNo = Math.min.apply(Math, _toConsumableArray(remainingNo));
            setArrayID([].concat(_toConsumableArray(arrayID), [nextNo]));
            updateSliderValues(selectedClassifications, arrayID.length + 1, "add");
        }
    };

    var handleSlider = function handleSlider(values) {
        // Never let value go to zero and only change middle handles
        var validClassification = selectedClassifications.filter(function (c) {
            return c.code != "" && c.value != "";
        });
        if (values.at(-1) === 100 && values.at(0) != 0 && values.length === validClassification.length) {
            setError(false);
            setSliderValue(values);
            updateSelectionPercentage(selectedClassifications, values);
            updateMarks(values);
        } else {
            setError(true);
        }
    };

    return _react2.default.createElement(
        _grid2.default,
        null,
        label && _react2.default.createElement(
            _row2.default,
            { nogutter: true },
            _react2.default.createElement(
                _column2.default,
                { nogutter: true },
                _react2.default.createElement(_label2.default, { text: label, textAlign: _alignments.Alignments.left, top: top })
            )
        ),
        _react2.default.createElement(
            _row2.default,
            null,
            _react2.default.createElement(AvatarContainer, { color: selectionColors && selectionColors[0], top: !label && top }),
            _react2.default.createElement(
                _column2.default,
                { xs: 10, md: 10, nogutterright: true },
                readOnly || arrayID.length > 1 ? _react2.default.createElement(_label2.default, {
                    size: _sizes.Sizes.md,
                    textAlign: _alignments.Alignments.left,
                    text: selectedClassifications.find(function (x) {
                        return x.id === 1;
                    }) ? selectedClassifications.find(function (x) {
                        return x.id === 1;
                    }).value : '-' }) : _react2.default.createElement(_dropDown2.default, {
                    key: 'DropDown11',
                    placeholder: '' + (error ? 'Select value before adding' : placeholder || 'Enter a profession'),
                    error: error,
                    value: selectedClassifications.find(function (x) {
                        return x.id === 1;
                    }) && { code: selectedClassifications.find(function (x) {
                            return x.id === 1;
                        }).code },
                    references: props.references.filter(function (elem) {
                        return !selectedClassifications.find(function (_ref4) {
                            var code = _ref4.code,
                                id = _ref4.id;
                            return elem.code === code && id != 1;
                        }) && elem.value;
                    }),
                    changeEvent: function changeEvent(value) {
                        setError(false);
                        var remainingSelection = selectedClassifications.filter(function (x) {
                            return x.id != 1;
                        });
                        if (Object.keys(value).length > 0) {
                            props.changeEvent(_extends({ componentCode: 'Row1' }, value, { "percentage": sliderValue[0] }));
                            setSelectedClassifications([].concat(_toConsumableArray(remainingSelection), [_extends({ "id": 1 }, value, { "percentage": sliderValue[0] })]));
                        } else {
                            props.changeEvent({ componentCode: 'Row1', code: "", value: "", percentage: 0 });
                            setSelectedClassifications([].concat(_toConsumableArray(remainingSelection), [{ "id": 1, code: "", value: "", "percentage": 0 }]));
                        }
                    },
                    filterMode: true
                })
            )
        ),
        !readOnly && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                _row2.default,
                { nogutter: true },
                _react2.default.createElement(
                    _column2.default,
                    { nogutter: true },
                    _react2.default.createElement(_header2.default, { text: '' + (addClassificationHeader || 'Do you have another class of your profession you want to add?'),
                        textAlign: _alignments.Alignments.left, size: _sizes.Sizes.lg, top: _sizes.Sizes.lg })
                )
            ),
            _react2.default.createElement(
                _row2.default,
                null,
                _react2.default.createElement(
                    _column2.default,
                    { nogutter: true },
                    _react2.default.createElement(_switch2.default, {
                        textLeft: 'No',
                        text: 'Yes',
                        bottom: _sizes.Sizes.sm,
                        value: addClassifications,
                        clickEvent: function clickEvent(value) {
                            return addMoreSwitch(value);
                        },
                        disabled: readOnly })
                )
            )
        ),
        addClassifications && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            Array.from(arrayID, function (e, i) {
                return i > 0 && i < 4 && _react2.default.createElement(
                    _row2.default,
                    null,
                    _react2.default.createElement(AvatarContainer, { color: selectionColors && selectionColors[i] }),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 10, md: 10, nogutterright: true },
                        readOnly || i < arrayID.length - 1 ? _react2.default.createElement(_label2.default, { size: _sizes.Sizes.md,
                            textAlign: _alignments.Alignments.left,
                            text: selectedClassifications.find(function (x) {
                                return x.id === e + 1;
                            }) ? selectedClassifications.find(function (x) {
                                return x.id === e + 1;
                            }).value : '-' }) : _react2.default.createElement(_dropDown2.default, {
                            key: 'DropDown' + (e + i),
                            placeholder: '' + (error ? 'Select value before adding' : placeholder || 'Enter a profession'),
                            error: error,
                            value: selectedClassifications.find(function (x) {
                                return x.id === e + 1;
                            }) && { code: selectedClassifications.find(function (x) {
                                    return x.id === e + 1;
                                }).code },
                            references: props.references.filter(function (elem) {
                                return !selectedClassifications.find(function (_ref5) {
                                    var code = _ref5.code,
                                        id = _ref5.id;
                                    return elem.code === code && id != e + 1;
                                }) && elem.value;
                            }),
                            changeEvent: function changeEvent(value) {
                                setError(false);
                                var remainingSelection = selectedClassifications.filter(function (x) {
                                    return x.id != e + 1;
                                });
                                var percentageValues = sliderValue.map(function (elem, idx) {
                                    return idx > 0 ? sliderValue.slice(idx - 1, idx + 1).reduce(function (a, b) {
                                        return b - a;
                                    }) : elem;
                                });
                                if (Object.keys(value).length > 0) {
                                    props.changeEvent(_extends({ componentCode: 'Row' + (e + 1) }, value, { "percentage": percentageValues[i] }));
                                    setSelectedClassifications([].concat(_toConsumableArray(remainingSelection), [_extends({ "id": e + 1 }, value, { "percentage": percentageValues[i] })]));
                                } else {
                                    props.changeEvent({ componentCode: 'Row' + (e + 1), code: "", value: "", "percentage": 0 });
                                    setSelectedClassifications([].concat(_toConsumableArray(remainingSelection), [{ "id": e + 1, code: "", value: "", "percentage": 0 }]));
                                }
                            },
                            disabled: readOnly,
                            filterMode: true
                        })
                    ),
                    !readOnly && i === arrayID.length - 1 && _react2.default.createElement(
                        DeleteDropDown,
                        { clickEvent: function clickEvent() {
                                return removeClassification(e + 1);
                            } },
                        _react2.default.createElement(_clear2.default, null)
                    )
                );
            }),
            arrayID.length < 4 && !readOnly && _react2.default.createElement(
                _row2.default,
                null,
                _react2.default.createElement(
                    _column2.default,
                    { xs: 10, md: 10, nogutterright: true },
                    _react2.default.createElement(_link2.default, { text: 'Add more', clickEvent: function clickEvent() {
                            return addMore();
                        }, textAlign: _alignments.Alignments.left, left: _sizes.Sizes.md })
                )
            ),
            _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    _row2.default,
                    null,
                    _react2.default.createElement(
                        _column2.default,
                        { nogutter: true },
                        _react2.default.createElement(_header2.default, { text: '' + (percentageHeader || 'What percentage do you work?'),
                            textAlign: _alignments.Alignments.left, size: _sizes.Sizes.lg, top: _sizes.Sizes.lg })
                    )
                ),
                _react2.default.createElement(
                    _row2.default,
                    null,
                    _react2.default.createElement(
                        SliderColumn,
                        { md: 12, lg: 12, xs: 12, nogutterleft: true, bottom: bottom },
                        _react2.default.createElement(StyledSlider, {
                            range: true,
                            value: sliderValue,
                            step: 5,
                            onChange: function onChange(value) {
                                return handleSlider(value);
                            },
                            allowCross: false,
                            pushable: 5,
                            marks: sliderMarks,
                            trackStyle: [{ backgroundColor: '' + (selectionColors[1] || _colors.Colors.Secondary), height: '10px' }, { backgroundColor: '' + (selectionColors[2] || _colors.Colors.Tertiary), height: '10px' }, { backgroundColor: '' + (selectionColors[3] || _colors.Colors.Success), height: '10px' }],
                            handleStyle: [{ backgroundColor: '' + (selectionColors[0] || _colors.Colors.Primary), borderColor: _colors.Colors.LightMode, height: '20px', width: '20px' }, { backgroundColor: '' + (selectionColors[1] || _colors.Colors.Secondary), borderColor: _colors.Colors.LightMode, height: '20px', width: '20px' }, { backgroundColor: '' + (selectionColors[2] || _colors.Colors.Tertiary), borderColor: _colors.Colors.LightMode, height: '20px', width: '20px' }, { backgroundColor: '' + (selectionColors[3] || _colors.Colors.Success), borderColor: _colors.Colors.LightMode, height: '20px', width: '20px' }],
                            railStyle: { backgroundColor: '' + (selectionColors[0] || _colors.Colors.Primary), height: '10px' },
                            disabled: readOnly || selectedClassifications.find(function (x) {
                                return x.percentage === 0;
                            }) && selectedClassifications.find(function (x) {
                                return x.percentage === 0;
                            }).length > 0
                        })
                    )
                )
            )
        )
    );
};

exports.default = Classification;